// Generated from MiningwareApi/Helpers/Enums.cs, PermissionAreaAttribute.cs and ExternalIdentity.cs - do not edit.
// Run `npm run gen:areas` after changing the OpenView enum, AreaSections, AreaLevel or a sign-in provider.

/** Every page the app knows about. Used as the view key and the SignalR group name. */
export const VIEW_KEYS = [
  "Account",
  "Analytes",
  "ApiKeys",
  "AreaGrants",
  "BlastHoleDrilling",
  "BlastHoleDrillingList",
  "BlastMaterial",
  "BlastMaterialType",
  "BlastPattern",
  "BucketFactors",
  "BucketTypes",
  "DailyReport",
  "DashboardTiles",
  "Densities",
  "DeviceMappings",
  "Dewatering",
  "DiggingLoadingSummary",
  "DowntimeSubtypes",
  "EditImportTemplate",
  "GeologyCrushing",
  "GeologyDrilling",
  "GeologyMilling",
  "GeologyOreBlocks",
  "GeologyOreTally",
  "GeologyRehandle",
  "Home",
  "Locations",
  "Login",
  "MachinePositions",
  "MaterialTypeClasses",
  "MaterialTypes",
  "MinePeriods",
  "MiningEquipment",
  "MiningMvtList",
  "MorningReport",
  "NewImportTemplate",
  "None",
  "Operations",
  "PitStages",
  "Plants",
  "PlantTypes",
  "Production",
  "ProductionOreTally",
  "RecalculateStockpiles",
  "ReportBuilder",
  "ReportDataConnections",
  "ReportLibrary",
  "ReverseCutDrilling",
  "RoyaltyAreaBalances",
  "RoyaltySplits",
  "SectionNames",
  "ShowMiningMvt",
  "StockpileBalances",
  "Stoppages",
  "TargetImport",
  "Targets",
  "TargetTypes",
  "UncheckedGpsStoppages",
  "Users",
  "Zones",
] as const;

export type ViewKey = (typeof VIEW_KEYS)[number];

/** The subset of views a zone can be granted. */
export const AREA_KEYS = [
  "Analytes",
  "BlastHoleDrilling",
  "BlastHoleDrillingList",
  "BlastMaterial",
  "BlastMaterialType",
  "BlastPattern",
  "BucketFactors",
  "BucketTypes",
  "DailyReport",
  "Densities",
  "DeviceMappings",
  "Dewatering",
  "DiggingLoadingSummary",
  "DowntimeSubtypes",
  "GeologyCrushing",
  "GeologyDrilling",
  "GeologyMilling",
  "GeologyOreBlocks",
  "GeologyOreTally",
  "GeologyRehandle",
  "Locations",
  "MachinePositions",
  "MaterialTypeClasses",
  "MaterialTypes",
  "MiningMvtList",
  "MorningReport",
  "Operations",
  "PitStages",
  "Plants",
  "PlantTypes",
  "Production",
  "ProductionOreTally",
  "RecalculateStockpiles",
  "ReportBuilder",
  "ReportDataConnections",
  "ReportLibrary",
  "RoyaltyAreaBalances",
  "RoyaltySplits",
  "ShowMiningMvt",
  "StockpileBalances",
  "Stoppages",
  "TargetImport",
  "Targets",
  "TargetTypes",
  "UncheckedGpsStoppages",
  "Zones",
] as const;

export type AreaKey = (typeof AREA_KEYS)[number];

export const SECTION_KEYS = [
  "admin",
  "db",
  "geology",
  "operations",
  "production",
  "reports",
  "royalty-area-balances",
  "royalty-splits",
  "stoppages",
] as const;

export type SectionKey = (typeof SECTION_KEYS)[number];

/** The default name of a nav section, before any per-mine override from sectionNames. */
export const SECTION_NAMES: Record<SectionKey, string> = {
  "operations": "Operations",
  "stoppages": "Stoppages",
  "production": "Production",
  "db": "Drill & Blast",
  "geology": "Geology",
  "reports": "Reports",
  "royalty-splits": "Royalty Splits",
  "royalty-area-balances": "Royalty Area Balances",
  "admin": "Admin",
};

/** The one display name for a page, shown in the nav, the title bar and the access screen. */
export const VIEW_NAMES: Record<ViewKey, string> = {
  Account: "Account",
  Analytes: "Analytes",
  ApiKeys: "API Keys",
  AreaGrants: "Zone Access",
  BlastHoleDrilling: "Add/Edit Blast Hole Drilling",
  BlastHoleDrillingList: "Blast Hole Drilling List",
  BlastMaterial: "Materials",
  BlastMaterialType: "Material Types",
  BlastPattern: "Patterns",
  BucketFactors: "Bucket Factors",
  BucketTypes: "Bucket Types",
  DailyReport: "Daily Report",
  DashboardTiles: "Dashboard Tiles",
  Densities: "Densities",
  DeviceMappings: "Device Mappings",
  Dewatering: "Dewatering",
  DiggingLoadingSummary: "Production List",
  DowntimeSubtypes: "Downtime Subtypes",
  EditImportTemplate: "Edit Import Template",
  GeologyCrushing: "Crushing",
  GeologyDrilling: "Drilling",
  GeologyMilling: "Milling",
  GeologyOreBlocks: "Ore Blocks",
  GeologyOreTally: "Ore Tally",
  GeologyRehandle: "Rehandle",
  Home: "Home",
  Locations: "Locations",
  Login: "Login",
  MachinePositions: "Machine Positions",
  MaterialTypeClasses: "Material Type Classes",
  MaterialTypes: "Material Types",
  MinePeriods: "Mine Periods",
  MiningEquipment: "Mining Equipment",
  MiningMvtList: "Mining Mvt List",
  MorningReport: "Morning Meeting Report",
  NewImportTemplate: "New Import Template",
  None: "None",
  Operations: "Operations List",
  PitStages: "Pit Stages",
  Plants: "Plant",
  PlantTypes: "Plant Types",
  Production: "Add/Edit Production",
  ProductionOreTally: "Ore Tally",
  RecalculateStockpiles: "Recalculate Stockpiles",
  ReportBuilder: "Eclipse Report Builder",
  ReportDataConnections: "Data Connections",
  ReportLibrary: "Report Library",
  ReverseCutDrilling: "Reverse Cut Drilling",
  RoyaltyAreaBalances: "Royalty Area Balances",
  RoyaltySplits: "Royalty Splits",
  SectionNames: "Section Names",
  ShowMiningMvt: "Show Mining Mvt",
  StockpileBalances: "Stockpile Balances",
  Stoppages: "Stoppages",
  TargetImport: "Target Imports",
  Targets: "Targets and EOM Actuals",
  TargetTypes: "Target Types",
  UncheckedGpsStoppages: "Unchecked GPS",
  Users: "Users",
  Zones: "Zones",
};

export const VIEW_SECTIONS: Partial<Record<ViewKey, SectionKey>> = {
  Analytes: "admin",
  BlastHoleDrilling: "db",
  BlastHoleDrillingList: "db",
  BlastMaterial: "db",
  BlastMaterialType: "db",
  BlastPattern: "db",
  BucketFactors: "admin",
  BucketTypes: "admin",
  DailyReport: "reports",
  Densities: "admin",
  DeviceMappings: "admin",
  Dewatering: "db",
  DiggingLoadingSummary: "production",
  DowntimeSubtypes: "admin",
  GeologyCrushing: "production",
  GeologyDrilling: "geology",
  GeologyMilling: "geology",
  GeologyOreBlocks: "geology",
  GeologyOreTally: "geology",
  GeologyRehandle: "production",
  Locations: "admin",
  MachinePositions: "operations",
  MaterialTypeClasses: "admin",
  MaterialTypes: "admin",
  MiningMvtList: "geology",
  MorningReport: "reports",
  Operations: "operations",
  PitStages: "admin",
  Plants: "admin",
  PlantTypes: "admin",
  Production: "production",
  ProductionOreTally: "production",
  RecalculateStockpiles: "geology",
  ReportBuilder: "reports",
  ReportDataConnections: "reports",
  ReportLibrary: "reports",
  RoyaltyAreaBalances: "royalty-area-balances",
  RoyaltySplits: "royalty-splits",
  ShowMiningMvt: "geology",
  StockpileBalances: "geology",
  Stoppages: "stoppages",
  TargetImport: "admin",
  Targets: "admin",
  TargetTypes: "admin",
  UncheckedGpsStoppages: "stoppages",
  Zones: "admin",
};

/** How much of an area a zone holds, as the numbers the API sends. */
export const AreaLevel = {
  Data: 1,
  Page: 2,
} as const;

export type AreaLevel = (typeof AreaLevel)[keyof typeof AreaLevel];

/** The external sign-in providers, by the key the API names each one. */
export const SSO_PROVIDER_KEYS = [
  "Google",
  "LinkedIn",
  "Microsoft",
] as const;

export type SsoProviderKey = (typeof SSO_PROVIDER_KEYS)[number];

const AREA_KEY_SET: ReadonlySet<string> = new Set(AREA_KEYS);

export const isAreaKey = (value: string | undefined): value is AreaKey =>
  value !== undefined && AREA_KEY_SET.has(value);
